import React, { Component } from 'react'


export default class extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="App" style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className='mb-5'>
                    <img src="https://cdn.jsdelivr.net/gh/gaewcha/vc-assets@main/ministry-of-public-health-logo.png" className="App-logo-err" alt="logo" />
                    {(this.props.isUnableRetrieveCert === true) && (<>
                        <h3 class="mt-5" style={{ overflowWrap: 'break-word', color: 'rgb(103, 109, 117)', fontWeight: '600' }}>
                            Cannot retrieve the requested certificate
                        </h3>
                        <br /><br />
                        <p style={{ paddingLeft: '4%', paddingRight: '4%', overflowWrap: 'break-word', textAlign: 'center' }}>
                            If you are recently issued with a certificate, please wait one working day before the certificate is ready. For further information, please contact DDC Thailand.
                        </p>
                    </>
                    )}
                    {(this.props.isCertCanceled !== 0) && (this.props.isUnableRetrieveCert !== true) && (
                        <h3 className='mt-5 mb-3' style={{ color: '#676D75', fontWeight: '600' }}>Certificate is invalid</h3>
                    )}
                    {(this.props.isCertCanceled === 0) && (this.props.isUnableRetrieveCert !== true) && (
                        <h3 className='mt-5 mb-3' style={{ color: '#676D75', fontWeight: '600' }}>Certificate is canceled</h3>
                    )}
                    {/* <h6 style={{color:'#676D75', fontWeight:'500'}} className='mt-2'>Certificate is invalid</h6> */}
                </div>
            </div>
        )
    }
}
